import React from "react";
import "../styles/UpiPage.css";
import UpiImg from "../assets/photos/upi.png";
import { FaBolt, FaQrcode, FaMobileAlt, FaShieldAlt } from "react-icons/fa";

function UpiPage() {
    return (
        <div className="upi-page">

            {/* HERO SECTION */}
            <section className="upi-hero">
                <div className="upi-hero-content">
                    <h1>UPI Services</h1>
                    <p>
                        The Sahyadri Sahakari Bank Ltd is working towards integrating
                        UPI services.
                    </p>
                </div>
            </section>

            {/* WHAT IS UPI SECTION */}
            <section className="upi-about">
                <div className="container">
                    <div className="upi-about-content">
                        <div className="upi-text">
                            <h2>What is UPI?</h2>
                            <p>
                                Unified Payments Interface (UPI) is a real-time digital payment
                                system that allows instant transfer of funds between bank accounts
                                using a mobile device. It enables secure transactions anytime,
                                anywhere with simple authentication.
                            </p>
                        </div>

                        <div className="upi-image">
                            <img src={UpiImg} alt="UPI Illustration" />
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURES SECTION */}
            <section className="upi-features">
                <div className="container">
                    <h2 className="section-title">What You Can Expect</h2>

                    <div className="features-grid">
                        <div className="feature-card">
                            <FaBolt />
                            <h3>Instant Transfers</h3>
                            <p>Send and receive money instantly 24x7.</p>
                        </div>

                        <div className="feature-card">
                            <FaQrcode />
                            <h3>QR Code Payments</h3>
                            <p>Scan and pay easily at shops and merchants.</p>
                        </div>

                        <div className="feature-card">
                            <FaMobileAlt />
                            <h3>Mobile Based Access</h3>
                            <p>Access UPI directly from your smartphone.</p>
                        </div>

                        <div className="feature-card">
                            <FaShieldAlt />
                            <h3>Secure Authentication</h3>
                            <p>Protected by UPI PIN and bank-level security.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* DIGITAL PROGRESS SECTION */}
            <section className="upi-progress">
                <h1>Work in Progress</h1>
                <div className="container">
                    <div className="progress-box">
                        <h2>UPI Integration in Progress</h2>
                        <p>
                            Our bank is currently upgrading its digital infrastructure to
                            introduce UPI services soon. We are committed to providing secure,
                            modern and reliable banking solutions to our valued customers.
                        </p>

                        <div className="progress-bar">
                            <div className="progress-fill"></div>
                        </div>

                        <span className="progress-text">Digital Upgrade Underway</span>
                    </div>
                </div>
            </section>

            {/* CONTACT SECTION */}
            <section className="upi-contact">
                <div className="container">
                    <h2>Stay Updated</h2>
                    <p>
                        For updates regarding UPI services, please visit your nearest branch
                        or contact our customer support team.
                    </p>
                    <b><p>customersupport@thesahyadribank.com</p></b>
                </div>
            </section>

        </div>
    );
}

export default UpiPage;